import React from 'react';
import { formatCharCustomizationLabel, normalizePersonalizationLetter } from '../productPersonalization';
import { describeJewelryCustomization, parseJewelryCustomization } from './jewelryCustomization';

/**
 * Human-readable customization for cart, checkout, admin orders, and track order.
 * @param {object} [props.product] Optional product snapshot for legacy orders without display map.
 */
export default function OrderCustomizationDisplay({
  raw,
  product = null,
  className = '',
  empty = null,
  detailed = false,
}) {
  const text = String(raw || '').trim();
  if (!text) {
    return empty;
  }

  if (!text.startsWith('j:')) {
    const letter = normalizePersonalizationLetter(text);
    if (letter) {
      return <span className={className}>{formatCharCustomizationLabel(letter)}</span>;
    }
    return <span className={className}>{text}</span>;
  }

  const jewelryParsed = parseJewelryCustomization(text);
  const jewelry = describeJewelryCustomization(text, product);
  if (!jewelry) {
    return jewelryParsed?.label ? (
      <span className={className}>{jewelryParsed.label}</span>
    ) : (
      <span className={className}>Customized</span>
    );
  }

  const photoField = jewelry.fields.find((f) => f.type === 'photo' && f.photoUrl);
  const photoUrl = photoField?.photoUrl || String(jewelryParsed?.values?.photo || '').trim();

  if (detailed && jewelry.fields.length > 0) {
    return (
      <span className={className}>
        {jewelry.fields.map((f) => (
          <span key={f.id} className="order-customization-display__line d-block">
            {f.type === 'photo' ? (
              <>
                {f.label}
                {f.photoUrl ? (
                  <a
                    href={f.photoUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ms-1"
                  >
                    (view photo)
                  </a>
                ) : null}
              </>
            ) : (
              <>
                <span className="order-customization-display__label">{f.label}:</span> {f.value}
              </>
            )}
          </span>
        ))}
      </span>
    );
  }

  return (
    <span className={className}>
      {jewelry.summary || jewelry.profileLabel || 'Customized'}
      {photoUrl ? (
        <a href={photoUrl} target="_blank" rel="noopener noreferrer" className="d-block small mt-1">
          View customer photo
        </a>
      ) : null}
    </span>
  );
}
